import { useMemo } from 'react';
import { useClaimedStatusByCampaign } from './useClaimedStatusByCampaign';
import { getUserTotalClaimableVlrWei } from './utils';
import { useAccount } from 'wagmi';
import { formatRewardsDisplay } from '../utils/rewardsCalculator';

export function useTotalWeiClaimable() {
  const { address } = useAccount();
  const { claimedByCampaign, isLoading, refetch } = useClaimedStatusByCampaign();
  console.log('claimedByCampaign:', claimedByCampaign);

  const totalWeiClaimable = useMemo(() => {
    if (isLoading) return null;
    if (!address) return null;
    return address ? getUserTotalClaimableVlrWei(address, claimedByCampaign) : null;
  }, [address, claimedByCampaign, isLoading]);

  const formatted = useMemo(() => {
    if (totalWeiClaimable === null || totalWeiClaimable === undefined) return null;
    const unitsAmount = Number(totalWeiClaimable) / 1e18;
    if (0 < unitsAmount && unitsAmount < 0.1) {
      // For small amounts, use toFixed(18) then remove trailing zeros
      const fixedString = unitsAmount.toFixed(18);
      // Remove trailing zeros after the decimal point
      return fixedString.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '') + ' VLR';
    }
    return formatRewardsDisplay(unitsAmount);
  }, [totalWeiClaimable]);
  return { totalWeiClaimable, formatted, refetch };
}
